export class BreadCrumbElement {
    // public url: string;
    // public title: string;

    constructor(public title: string, public url: string) {

    }
}
